// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingLayout_loader__2Syyg","load5":"LoadingLayout_load5__3a75H"};